import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {RestDataSource} from '../../shared/rest-data-source';
import {MatSort} from '@angular/material/sort';
import {PaginatorComponent} from '../../shared/paginator';
import {AppLoaderComponent} from '../../shared/app-loader/app-loader.component';
import {EformAPI} from '../e-form.api';
import {ActivatedRoute, Router} from '@angular/router';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {Toast} from '../../shared/toast/toast';
import {TranslateService} from '@ngx-translate/core';
import {MatLegacySlideToggleChange as MatSlideToggleChange} from '@angular/material/legacy-slide-toggle';
import {FormGenerateComponent} from '../form-generate/form-generate.component';
import {DeleteFormComponent} from '../dialog/delete-form/delete-form.component';

@Component({
   selector: 'app-form-list-dialog',
   templateUrl: './form-list-dialog.component.html',
   styleUrls: ['./form-list-dialog.component.css']
})
export class FormListDialogComponent implements OnInit {
   @ViewChild(MatSort) sort: MatSort;
   @ViewChild(PaginatorComponent, {static: true}) paginator: PaginatorComponent;
   @ViewChild('wrapper') container: ElementRef;
   @ViewChild(AppLoaderComponent, {static: true}) loader: AppLoaderComponent;
   @ViewChild('search', {static: true}) search: ElementRef;

   private timer: any;
   dataSource = new RestDataSource<any>();
   formType: string;
   selectedRowIndex: number;
   displayedColumns = ['formName', 'createdBy', 'updateDate', 'versions'];
   filterValue = '';
   orderBy = '';
   orderType = '';
   sortOrder = 'formName';
   sortDirect = 'asc';
   searchFocused: boolean;
   index: any;
   size: any;
   searchResult: any[];
   preventBlur: boolean;
   searchvalue: any;
   searching: any;
   draft: any;
   publish: any;
   allData: any[] = [];
   isLoadingResults = false;
   formList = [];
   isSelectAll = false;
   disabledBtn = true;
   data: any;
   path: string;

   constructor(@Inject(MAT_DIALOG_DATA) private injectData: any, private api: EformAPI, private route: ActivatedRoute, private dialog: MatDialog,
               private toast: Toast, private translate: TranslateService, private router: Router) {
   }

   ngOnInit(): void {
      localStorage.setItem('callback-url', this.router.url);
      localStorage.setItem('form-type', 'dms');
      localStorage.setItem('form-path', this.path);
      this.formType = 'FM';
      this.getListForm('');
   }

   onClickEForm(formId: number) {
      this.selectedRowIndex = formId;
      this.router.navigate(['/eform/create/' + formId],{ queryParams: {isCreateFile :true}});
      this.injectData.formListDialog.close();
   }

   getListForm(type) {
      this.loader.show();
      this.selectedRowIndex = -1;
      this.isLoadingResults = true;
      this.dataSource = new RestDataSource<any>();
      this.dataSource.paginator = this.paginator;
      this.index = this.paginator.page;
      this.size = this.paginator.size;
      localStorage.setItem('page_index', this.index);

      if (this.size === undefined) {
        this.size = 50;
      }

      if (this.sort) {
        this.dataSource.sort = this.sort;
      }

      this.sortOrder = localStorage.getItem('sortOrderDialog') || 'updateDate';
      this.sortDirect = localStorage.getItem('sortDirect') || 'desc';

      if (type === 'sort' && this.sort) {
        this.sortOrder = this.sort.active;
        this.sortDirect = this.sort.direction;
        localStorage.setItem('sortOrderDialog', this.sortOrder);
        localStorage.setItem('sortDirect', this.sortDirect);
      }
      this.api.listEFormOnlyActive(this.formType, localStorage.getItem('tin'), encodeURIComponent(this.filterValue.trim()), this.sortOrder, this.sortDirect, this.index, this.size, null)
        .subscribe(data => {
          const formPromises = data.content.map(item => this.api.getEForm(item.formId).toPromise());

          Promise.all(formPromises).then(responses => {
            responses.forEach((dataSource, index) => {
               if (dataSource.body && dataSource.body.data && dataSource.body.data.formName) {
                  const formName = dataSource.body.data.formName;
                  const currentLang = this.translate.currentLang;

                  if (formName.th && currentLang === 'th') {
                    data.content[index].formName = formName.th;
                  } else if (formName.en && currentLang === 'en') {
                    data.content[index].formName = formName.en;
                  } else if (formName.cn && currentLang === 'cn') {
                    data.content[index].formName = formName.cn;
                  }
                  
                } 
            });

            data.content = data.content.filter(item => item.isActive && item.publishBy);

            this.data = data;
            for (const list of data.content) {
              list.createdDate = new Date(list.createdDate.replace(/-/g, '/'));
              list.updateDate = new Date(list.updateDate.replace(/-/g, '/'));
            }

            this.dataSource.loaded(data);
            this.allData = data.content;
            this.isLoadingResults = false;
            if (this.allData.length === 0) {
              this.isLoadingResults = true;
            }
            this.container.nativeElement.scrollTop = 0;
            this.loader.hide();
          }).catch(e => {
            this.handleErrors(e);
            this.loader.hide();
          });
        }, e => {
          this.handleErrors(e);
          this.loader.hide();
        });
    }

   // Wait for Specification Error Message
   handleErrors(e: any) {
      if (e.status === 404) {
         this.toast.error('Service Not Found.');
      }
   }

   activeFormList(id: any, event: MatSlideToggleChange) {
      this.api.activeFormList(id, event.checked)
         .subscribe((response) => {
            // This is intentional
         }, e => {
            this.handleErrors(e);
         });
   }

   clearData() {
      this.paginator.firstPage();
      this.filterValue = '';
      this.search.nativeElement.value = '';
      this.disabledBtn = true;
      this.formList = [];
      this.isSelectAll = false;
   }

   onSearch(value: any) {
      this.searchFocused = false;
      this.searchvalue = value;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const q = encodeURIComponent(value.trim());
      if (q.length === 0) {
         value = '';
      } else {
         value = value.trim(); // Remove whitespace
         value = value.toLowerCase();
      }
      this.filterValue = value;
      this.getListForm('');
   }

   onSearchChange(input: any, e: any) {
      localStorage.setItem('searchValue', input.value);
      if (e.keyCode !== 13) {
         this.searchFocused = true;
      }

      this.searchResult = null;
      this.searchChange(input);
   }

   onSearchFocus(input: any) {
      this.searchFocused = true;
      this.searchChange(input);
   }

   onSearchBlur() {
      setTimeout(() => {
         if (!this.preventBlur) {
            this.searchFocused = false;
         }
      }, 300);
   }

   searchChange(input) {
      if (this.timer) {
         clearTimeout(this.timer);
      }
      this.filterValue = encodeURIComponent(input.value.trim());
      if (this.filterValue.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         this.api.listEFormOnlyActive(this.formType, localStorage.getItem('tin'), this.filterValue, this.orderBy,
            this.orderType, 0, 8, null)
            .subscribe(
               data => {
                  data.content = data.content.filter(item => item.isActive && item.publishBy );
                  if (this.timer == null) {
                     this.searchResult = data.content;
                  }
               });
      }, 300);
   }

   openPreview(formId: any) {
      const dialogRef = this.dialog.open(FormGenerateComponent, {
         disableClose: true,
         data: {
            formId: formId
         },
         panelClass: 'my-dialog',
         width: '1350px',
         height: 'auto'
      });
      dialogRef.componentInstance.isPreview = true;

      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            this.translate.get('eform.submit.success').subscribe(s => {
               this.toast.success(s);
            });
         }
      });
   }

   onClickDel(formId: any) {
      const dialogRef = this.dialog.open(DeleteFormComponent, {
         disableClose: true,
         height: '110px',
         data: {
            formId: formId,
            formList: this.dataSource.selected
         },
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result.response) {
            if (result.msg.code === 200) {
               this.toast.success(result.msg.message);
               this.clearData();
               this.getListForm('');
            } else {
               this.toast.error(result.msg.message);
            }
         }
      });
   }

   selectCheckbox(event, formId) {
      if (formId === -1) {
         this.isSelectAll = event.checked;
      }
      const checkFormList = this.checkFormList(this.dataSource.selected);
      this.disabledBtn = (!checkFormList && !this.isSelectAll) ? true : false;
   }

   checkFormList(formList) {
      if (formList.length === 0) {
         return false;
      } else {
         return true;
      }
   }
}
